import { widgetViewNames } from 'src/constants/widgets';

/**
 * @return {boolean}
 */
export const isTriTech = state =>
  state.widgetView.name === widgetViewNames.triTech;
